import { CryptoCurrencyIcon } from '@/components/primitives';
import { useChainCurrency } from '@/hooks/use-chain-currency';
import { getChainExplorerUrl } from '@/utils/chainExplorers';
import { Link, Text, type LinkProps } from '@chakra-ui/react';
import { formatAddress } from '@onbeam/utils';

interface Props extends LinkProps {
  chainId: number;
  contractAddress: string | null;
}

export const CollectionLink = ({ chainId, contractAddress, ...props }: Props) => {
  const { address } = useChainCurrency(chainId);

  return (
    <Link
      href={contractAddress ? getChainExplorerUrl(chainId, contractAddress, 'address') : undefined}
      rel="noopener noreferrer"
      display="flex"
      fontWeight="medium"
      target="_blank"
      title={contractAddress ?? undefined}
      transition="opacity 120ms ease-in-out"
      gap="space.6"
      {...props}
    >
      <CryptoCurrencyIcon css={{ height: 20 }} address={address} />
      {contractAddress && <Text lineHeight="lg">{formatAddress(contractAddress)}</Text>}
    </Link>
  );
};
